<template>
  <div class="attr-nav-item">
    <div class="nav-item--wrap">
      <el-radio-group v-model="value.button.hasBT">
        <el-radio :label="true">有按钮</el-radio>
        <el-radio :label="false">无按钮</el-radio>
      </el-radio-group>
      <div v-if="value['button'].hasBT">
        <el-input v-model="value.button.btText" placeholder="按钮名称" />
        <div class="nav-item--picker">
          <CompPickerLink
            :value="value['button']"
            @change="
              (e) => {
                handleChangeGoods(e)
              }
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import CompPickerLink from '../../comps/comp-pickerLink'
export default {
  name: 'AttrBtNavItem',
  components: { CompPickerLink },
  props: {
    value: [Object, Array]
  },
  mounted() {
    console.log(this.value.button)
  },
  methods: {
    handleChangeGoods(e) {
      Vue.set(this.value, 'button', {
        ...this.value['button'],
        ...e
      })
      console.log(this.value.button)
    }
  }
}
</script>
<style lang="scss">
.attr-nav-item {
  .nav-item--picker {
    display: flex;
    margin-top: 10px;
  }
  // .cell-value-tip {
  //   position: relative;
  //   top: -12px;
  // }
}
</style>
